module.exports = __webpack_public_path__ + "img/card-holder-bg-widget.02930693.png";